"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPostSportStreamingPlatformsDto = instanceOfPostSportStreamingPlatformsDto;
exports.PostSportStreamingPlatformsDtoFromJSON = PostSportStreamingPlatformsDtoFromJSON;
exports.PostSportStreamingPlatformsDtoFromJSONTyped = PostSportStreamingPlatformsDtoFromJSONTyped;
exports.PostSportStreamingPlatformsDtoToJSON = PostSportStreamingPlatformsDtoToJSON;
exports.PostSportStreamingPlatformsDtoToJSONTyped = PostSportStreamingPlatformsDtoToJSONTyped;
var PostSportDigestOptionDto_1 = require("./PostSportDigestOptionDto");
var DigestCopyDto_1 = require("./DigestCopyDto");
/**
 * Check if a given object implements the PostSportStreamingPlatformsDto interface.
 */
function instanceOfPostSportStreamingPlatformsDto(value) {
    if (!('preamble' in value) || value['preamble'] === undefined)
        return false;
    if (!('question' in value) || value['question'] === undefined)
        return false;
    if (!('required' in value) || value['required'] === undefined)
        return false;
    if (!('options' in value) || value['options'] === undefined)
        return false;
    return true;
}
function PostSportStreamingPlatformsDtoFromJSON(json) {
    return PostSportStreamingPlatformsDtoFromJSONTyped(json, false);
}
function PostSportStreamingPlatformsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'preamble': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['preamble']),
        'question': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['question']),
        'required': json['required'],
        'options': (json['options'].map(PostSportDigestOptionDto_1.PostSportDigestOptionDtoFromJSON)),
    };
}
function PostSportStreamingPlatformsDtoToJSON(json) {
    return PostSportStreamingPlatformsDtoToJSONTyped(json, false);
}
function PostSportStreamingPlatformsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'preamble': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['preamble']),
        'question': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['question']),
        'required': value['required'],
        'options': (value['options'].map(PostSportDigestOptionDto_1.PostSportDigestOptionDtoToJSON)),
    };
}
